import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { addDeal } from '../../actions/deal';
import DatePicker from 'react-date-picker';
import moment from 'moment';
import { Button, makeStyles, Icon, Link } from '@material-ui/core';

const AddDeal = ({ addDeal, contactID, contact }) => {
  const useStyles = makeStyles(theme => ({
    newDealBody: {
      padding: '5px',
      background: '#F2F4F4'
    },
    dealNameHead: {
      fontSize: '2rem'
    },
    addButton: {
      marginBottom: '10px'
    }
  }));

  const classes = useStyles();
  const [timeValue, onChange] = useState(new Date());

  const [formData, setFormData] = useState({
    nameNew: '',
    amountNew: '',
    noteNew: '',
    timeNew: ''
  });

  const [clicked, setClicked] = useState(false);

  const onClick = e => {
    e.preventDefault();
    setClicked(true);
  };

  const onClickCancel = e => {
    e.preventDefault();
    setClicked(false);
  };

  const { nameNew, amountNew, noteNew } = formData;

  const onChangeInput = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = e => {
    e.preventDefault();
    let difference = moment().diff(moment(timeValue), 'seconds');
    if (difference < 0) {
      formData.time = timeValue;
      addDeal(formData, contactID);
      setClicked(false);
    }
    setFormData({ nameNew: '', amountNew: '', noteNew: '', timeNew: '' });
  };

  return (
    <Fragment>
      <Button
        variant='outlined'
        onClick={e => onClick(e)}
        className={classes.addButton}
      >
        {' '}
        <Icon
          class='fas fa-plus'
          style={{ color: '#91CFEC', paddingRight: '5px' }}
        ></Icon>{' '}
        Add deal
      </Button>
      {clicked && (
        <div className={classes.newDealBody}>
          <h3>New Deal</h3>{' '}
          <div>
            <DatePicker onChange={onChange} value={timeValue} />
          </div>
          <form className='na-form' onSubmit={e => onSubmit(e)}>
            <div className='form-group'>
              <input
                type='text'
                placeholder='Deal'
                name='nameNew'
                value={nameNew}
                onChange={e => onChangeInput(e)}
                required
              />
            </div>
            <div className='form-group'>
              <input
                type='number'
                placeholder='Amount'
                name='amountNew'
                value={amountNew}
                onChange={e => onChangeInput(e)}
                required
              />
            </div>
            <div className='form-group'>
              <input
                type='text'
                placeholder='Note'
                name='noteNew'
                value={noteNew}
                onChange={e => onChangeInput(e)}
              />
            </div>
            <input type='submit' className='btn btn-firm' value='Save' />
            <Link href='#' onClick={e => onClickCancel(e)}>
              Cancel
            </Link>
          </form>
        </div>
      )}
    </Fragment>
  );
};

AddDeal.propTypes = {
  contactID: PropTypes.object.isRequired,
  addDeal: PropTypes.func.isRequired,
  contact: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  contact: state.contact
});

export default connect(mapStateToProps, { addDeal })(AddDeal);



// WEBPACK FOOTER //
// ./src/components/deal/AddDeal.js